import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, map, take } from 'rxjs';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for auth loading to complete before checking
  return authService.isLoading$.pipe(
    filter(loading => !loading),
    take(1),
    map(() => {
      if (!authService.isAuthenticated) {
        return false;
      }

      if (authService.isAdmin) {
        return true;
      }

      // Redirect non-admin users to the home page
      router.navigate(['/']);
      return false;
    })
  );
};
